import { render, staticRenderFns } from "./StatsButtons.vue?vue&type=template&id=7b05fb28&"
import script from "./StatsButtons.vue?vue&type=script&lang=js&"
export * from "./StatsButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b05fb28')) {
      api.createRecord('7b05fb28', component.options)
    } else {
      api.reload('7b05fb28', component.options)
    }
    module.hot.accept("./StatsButtons.vue?vue&type=template&id=7b05fb28&", function () {
      api.rerender('7b05fb28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Packages/FIlesPreviewer/components/StatsButtons.vue"
export default component.exports